import config from '../config';
import { REFERRAL, REFERRAL_PUBLIC_APPEND } from '../constants/urls';
import {
  CreateReferrerQuery,
  Customer,
  ExternalCustomer,
  GetReferrerByCustomerIdQuery,
} from '../gql/generated/graphql';
import { Referrer } from './types/referrer';

export const buildReferrerPayload = (
  referrerId: number,
  customer: Customer | ExternalCustomer,
) => ({
  referrer_id: referrerId,
  first_name: customer.first_name ?? '',
  last_name: customer.last_name ?? '',
  email: customer.email ?? '',
  phone_number: customer.phone_number ?? '',
  address_line_1: customer.address?.address_line ?? '',
  address_city: customer.address?.city ?? '',
  address_state: customer.address?.state ?? '',
  address_postal_code: customer.address?.zip ?? '',
});

type GraphRef =
  | NonNullable<GetReferrerByCustomerIdQuery['getReferrerByCustomerId']>
  | NonNullable<CreateReferrerQuery['createReferrer']>;

export function mapGraphReferrer(graphRef: GraphRef): Referrer {
  return {
    id: Number(graphRef.id),
    code: graphRef.code,
    opted_in_at: graphRef.opted_in_at,
    finix_identity: graphRef.finix_identity,
    finix_instrument: graphRef.finix_instrument,
    finix_verify: graphRef.finix_verify,
    finix_merchant: graphRef.finix_merchant,
    instrument_type: graphRef.instrument_type,
    instrument_brand: graphRef.instrument_brand,
    instrument_last_four: graphRef.instrument_last_four,
    instrument_exp_mo: graphRef.instrument_exp_mo,
    instrument_exp_yr: graphRef.instrument_exp_yr,
    url_views: graphRef.url_views ?? 0,
    flow_starts: graphRef.flow_starts ?? 0,
  };
}

export const buildReferralUrl = (data: {
  code: string | null;
  isPublic?: boolean;
  utms?: {
    medium: string;
    campaign: string;
  };
}) => {
  const { code, isPublic, utms } = data;
  const utmVals = !utms ? '' : `?utm_medium=${utms.medium}&utm_campaign=${utms.campaign}`;
  return !code
    ? ''
    : `${config.mktUrl}${REFERRAL}${code}${isPublic ? REFERRAL_PUBLIC_APPEND : ''}${utmVals}`;
};
